import { render, staticRenderFns } from "./CustomerOrderModeDelivery.vue?vue&type=template&id=1f72e5d8&scoped=true"
import script from "./CustomerOrderModeDelivery.vue?vue&type=script&lang=js"
export * from "./CustomerOrderModeDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f72e5d8",
  null
  
)

export default component.exports